export const server = "https://invoice.consciousgrp.com:8002/api/v2";
export const backend_url = "https://invoice.consciousgrp.com:8002/";

